import { ROUTE_ACCOUNT_EDIT_PERSONAL_INFO } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './edit-personal-info.page';

export const routeEditPersonalInfo: RouteObject = {
  path: ROUTE_ACCOUNT_EDIT_PERSONAL_INFO,
  Component: Page,
  loader: setTitleFromLoader('Personal Info'),
};
